/**
 * Dependencies :
 * - FileSaver : https://github.com/eligrey/FileSaver.js/
 * - JSZIP : https://github.com/Stuk/jszip
 * - JSZipUtils : https://github.com/Stuk/jszip-utils
 */

/**
 *
 * @param files : []
 * Ex :
 * [
 *      {
 *          name: "filename.xxx",
 *          url: "https://filename.url"
 *      }
 * ]
 * @param archiveName : String
 * @param beforeSave : function
 * @param onFinish : function
 */
function downloadPdfFiles(files, archiveName, beforeSave, onFinish){

    let zip = new JSZip();
    let promiseChain = new Promise((resolve, reject) => resolve());
    files.forEach(function(file, index, files){
        promiseChain = promiseChain.then(() => _addRemoteFileToZip(file.url, file.name, zip));
        if(index === files.length - 1){
            promiseChain.then(function () {
                if (typeof beforeSave == 'function')
                    beforeSave();
                })
                .then(() => zip.generateAsync({type: "blob"}))
                .then((content) => saveAs(content, `${archiveName}.zip`))
                .then(function () {
                    if(typeof onFinish == 'function')
                        onFinish();
                })
                .catch(function (err) {
                    throw err;
                });
        }
    })
}

function _addRemoteFileToZip(url, filename, zipObject){
    return new Promise(function (resolve, reject) {
        JSZipUtils.getBinaryContent(url, function (err, data) {
            if (err)
                reject(err);

            try {
                zipObject.file(filename, data, {binary: true});
            } catch (e) {
                reject(e);
            }

            resolve();
        });
    });
}

function handleDownloadClick(archiveName){
    jQuery.LoadingOverlay("show", {text: "🍋 Téléchargement en cours !🍋" || false});
    let pdfData = jQuery('#pdf-data');
    let filesData = pdfData.text();
    let customer_id = pdfData.data('customer-id');
    let product_id = pdfData.data('product-id');
    let product_sku = pdfData.data('product-sku');
    let product_handle = pdfData.data('product-handle');
    let must_log_download = pdfData.data('log-download');
    let must_decrement = pdfData.data('decrement');
    if (!filesData.length || !customer_id || !product_id){
        _handleDownloadError();
        return;
    }

    let files = [];
    JSON.parse(filesData).split('|###|').forEach(function (value) {
        let parts  = value.split(';');
        files.push({
            name: parts[0].trim().concat('.pdf'),
            url: parts[1].trim()
        })
    });

    try {
        downloadPdfFiles(files, archiveName,
                _beforeSaveHandler.bind(null,customer_id, product_id, must_decrement)
                , _onFinishHandler.bind(null, customer_id, product_id, product_handle, product_sku, must_log_download));
    } catch (e) {
        _handleDownloadError();
    }

}

function _handleDownloadError()
{
    jQuery.LoadingOverlay("hide");
    Swal.fire({
        title: "Erreur",
        text: "Une erreur est survenue. Ré-essaye ou contacte notre service client !",
        icon: 'error',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#171717'
    })
}

function _beforeSaveHandler(customer_id, product_id, must_decrement_limit ) {
    if (must_decrement_limit) {
        jQuery.post({
            url: 'https://europe-west1-onyx-descent-309314.cloudfunctions.net/mml-decrease-pdf-download-limit',
            data: JSON.stringify({
                customer_id: customer_id,
                product_id: product_id
            }),
            headers: {'Content-Type': 'application/json'}
        });
    }
}

function _onFinishHandler(customer_id, product_id, product_handle, product_sku, must_log_download) {
    if(must_log_download){
        jQuery.post({
            url: 'https://log-pattern-download-fn7ygb3mjq-ew.a.run.app',
            data: JSON.stringify({
                customer_id: customer_id,
                pattern_id: product_id,
                pattern_handle:product_handle,
                pattern_sku: product_sku
            }),
            headers: {'Content-Type': 'application/json'}
        });
    }

    jQuery.LoadingOverlay("hide");
    Swal.fire({
        title: "Téléchargé !",
        text: "Si vous êtes sur mobile, vérifiez vos notifications et/ou votre gestionnaire de téléchargements.",
        icon: 'success',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#171717'
    })
}

jQuery(document).ready(function(){
    jQuery('[data-download-pdf]').on('click', function () {
        handleDownloadClick(jQuery(this).data('download-pdf'));
    })
});